import { render, staticRenderFns } from "./orgLanguages.vue?vue&type=template&id=7fabf634&scoped=true&"
import script from "./orgLanguages.vue?vue&type=script&lang=js&"
export * from "./orgLanguages.vue?vue&type=script&lang=js&"
import style0 from "./orgLanguages.vue?vue&type=style&index=0&id=7fabf634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fabf634",
  null
  
)

export default component.exports